export enum QueryKey {
  getRefunds = 'getRefunds',
  getRefund = 'getRefund',
  exportRefunds = 'exportRefunds',
  acceptRefund = 'acceptRefund',
  rejectRefund = 'rejectRefund',
}
